import { render, staticRenderFns } from "./dispersion-queue-status.vue?vue&type=template&id=66ddd12f&scoped=true&"
import script from "./dispersion-queue-status.vue?vue&type=script&lang=js&"
export * from "./dispersion-queue-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddd12f",
  null
  
)

export default component.exports